import config from "../Config/config";

const fetchProjectDecisions = async (uid, setDecisions, setError) => {
  try {
    const response = await fetch(
      `${config.serverBaseUrl}/decision/all/${uid}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      },
    );

    if (!response.ok) {
      throw new Error("Decisions not found");
    }

    const resJson = await response.json();
    const data = resJson.data;
    setDecisions(data.decisions);
  } catch (error) {
    console.log(error);
    setError(error.message);
  }
};

const resolveDecision = async (
  decision_id,
  resolve,
  uid,
  setDecisions,
  setAlert,
  setError,
) => {
  try {
    const response2 = await fetch(`${config.serverBaseUrl}/decision/resolve`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        decision_id: decision_id,
        resolved: resolve,
      }),
    });

    if (response2.ok) {
      fetchProjectDecisions(uid, setDecisions, setError);
    } else {
      setAlert({ severity: "error", message: "Failed to submit decision" });
    }
  } catch (error) {
    console.error("Error submitting decision:", error);
    setAlert({ severity: "error", message: "Error submitting decision" });
  }
};

const submitDecision = async (
  decision,
  comments,
  setAlert,
  project,
  decisionByRole,
  code,
  serialNumber,
  syncToMyHours,
  syncToJoosep,
  refreshDecision,
) => {
  if ((decision === "review" || decision === "reject") && !comments) {
    setAlert({
      severity: "warning",
      message: "Please include comments to explain your decision",
    });
    return;
  }
  try {
    // Request 2 - record new decision for the project
    const response = await fetch(
      `${config.serverBaseUrl}/decision/${decision}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          decision_id: undefined,
          project_id: project.project_id,
          comments: comments,
          decision_by_role: decisionByRole,
          code,
          serialNumber,
          syncToMyHours,
          syncToJoosep,
        }),
      },
    );

    if (response.ok) {
      setAlert({
        severity: "success",
        message: "Decision submitted successfully",
      });
      refreshDecision();
    } else {
      const resJson = await response.json();
      setAlert({
        severity: "error",
        message: resJson.message ?? "Failed to submit decision",
      });
    }
  } catch (error) {
    console.error("Error submitting decision:", error);
    setAlert({ severity: "error", message: "Error submitting decision" });
  }
};

export { fetchProjectDecisions, resolveDecision, submitDecision };
